import { render, staticRenderFns } from "./ConfirmationForgotPassword.vue?vue&type=template&id=b4b72102&scoped=true"
import script from "./ConfirmationForgotPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmationForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationForgotPassword.vue?vue&type=style&index=0&id=b4b72102&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b72102",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4b72102')) {
      api.createRecord('b4b72102', component.options)
    } else {
      api.reload('b4b72102', component.options)
    }
    module.hot.accept("./ConfirmationForgotPassword.vue?vue&type=template&id=b4b72102&scoped=true", function () {
      api.rerender('b4b72102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/pages/login/ConfirmationForgotPassword.vue"
export default component.exports